import React from "react";
import { Checkbox } from "../ui/checkbox";

const MultiSelector = ({ options, selectedValue, setSelectedValue, id }) => {
  const toggleSelection = (value) => {
    const newValue = selectedValue.includes(value)
      ? selectedValue.filter((v) => v !== value)
      : [...selectedValue, value];
    setSelectedValue(newValue);
  };

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-3">
      {options.map((item) => {
        const strVal = String(item.value);
        const isSelected = selectedValue.includes(strVal);
        const checkboxId = `${id}_${item.value}`;

        return (
          <div
            key={checkboxId}
            className="flex items-center gap-2 w-full px-3 py-2 border rounded-lg bg-background border-gray-200 hover:shadow-sm transition-shadow min-h-[48px]"
          >
            <Checkbox
              id={checkboxId}
              checked={isSelected}
              onCheckedChange={() => toggleSelection(strVal)}
              className={`w-5 h-5 rounded-md border border-gray-200 flex items-center justify-center transition-colors
                ${isSelected ? "bg-button-coloured border-transparent" : "bg-background"}`}
            >
              {isSelected && (
                <svg
                  className="w-3 h-3 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={3}
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </Checkbox>
            <span className="text-sm font-normal select-none">{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MultiSelector;
